import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=59687f4e&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=59687f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59687f4e",
  null
  
)

export default component.exports